import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import lang from '@blade/common/pages/result-details/lang/indexTask';
import { IncidentTypeMapArr, crowdAndIndividual, faceList, showConfidence } from '@blade/common/pages/result-details/common/config';
import { formatTime } from '@blade/common/pages/crowd-queue-right/utils/index';
let detailsThreshold = class detailsThreshold extends Vue {
    details;
    formatTime = formatTime;
    getDetailsIncidentType(val) {
        let newText = '';
        const incidentAttrObj = IncidentTypeMapArr.find((d) => d.incidentType === val.incidentType);
        if (incidentAttrObj && incidentAttrObj.alarmDetailI18n) {
            if (crowdAndIndividual.includes(val.incidentType)) {
                newText = this.$t(incidentAttrObj.alarmDetailI18n, { num: val.crowdAnnotation?.value }).toString();
            }
            if (showConfidence.includes(val.incidentType)) {
                newText = `${this.$t(incidentAttrObj.alarmDetailI18n)}${this.getConfidenceValue(val.commonAnnotation)}`;
                if (val.incidentType === 'INCIDENT_TRAFFIC_ILLEGAL_STOP') {
                    newText = `${this.$t(incidentAttrObj.alarmDetailI18n)}${this.getConfidenceValue(val.trafficAnnotation)}`;
                }
                if (val.incidentType === 'INCIDENT_TRAFFIC_RETROGRADE') {
                    newText = `${this.$t(incidentAttrObj.alarmDetailI18n)}${this.getConfidenceValue(val.trafficAnnotation)}`;
                }
            }
        }
        else {
            if (faceList.includes(val.incidentType)) {
                if (val.incidentType === 'FACE_MATCH') {
                    newText = val.faceAnnotation?.portraitName;
                }
                if (val.incidentType === 'FACE_PEDESTRIAN') {
                    newText = val.pedestrianAnnotation?.portraitName;
                }
            }
        }
        return newText;
    }
    getConfidenceValue(val) {
        let newVal = '';
        if (val?.value) {
            newVal = `${this.$t('comma')} ${this.$t('confidence')} ${Math.round(val?.value * 100)}%`;
        }
        return newVal;
    }
};
__decorate([
    Prop()
], detailsThreshold.prototype, "details", void 0);
detailsThreshold = __decorate([
    Component({
        name: 'detailsThreshold',
        components: {},
        i18n: {
            messages: lang,
        },
    })
], detailsThreshold);
export default detailsThreshold;
